// src/pages/CSR.jsx
import React from 'react'

const Hero = ({ title, subtitle, images, backgroundImage, showButtons = true }) => (
  <div className="relative h-screen z-10  overflow-hidden">
    {/* Background Image */}
    <div 
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage || images[0]})` }}
    >
      <div className="absolute inset-0 bg-black/40"></div>
    </div>

    {/* Content Overlay */}
        <div className="relative z-10 h-full flex items-center justify-center text-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="mx-auto max-w-2xl">
              <h1 className="font-libre text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6">
                {title}
              </h1>
              <p className="font-inter text-lg text-gray-200">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
  </div>
)

const CSR = () => {
  const initiatives = [
    {
      title: 'Data-Centered',
      description: 'We provide reliable housing data and analytics for use at any time',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    {
      title: 'Advocacy',
      description: 'We advance advocacy on housing affordability.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
        </svg>
      )
    },
    {
      title: 'Partnerships',
      description: 'We build partnerships with governments, NGOs, and investors',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    },
    {
      title: 'Green Initiatives',
      description: 'We promote eco-friendly housing initiatives to improve quality of life',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      )
    }
  ]


  return (
    <div className="min-h-screen bg-white">
        <Hero 
        title="Corporate Social Responsibility"
        subtitle="We provide integrated lifecycle solutions in real estate consultancy that allows clients"
        backgroundImage="/csrmaybeimage.jpg"
      />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        
      {/* Mission Statement */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 font-inter">
            Ofanda Africa commits to building Africa's future beyond profit through the Ofanda Africa Housing Foundation.
          </h2>
        </div>
      </div>

      {/* Initiatives Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {initiatives.map((initiative, index) => (
            <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 hover:shadow-lg transition-shadow duration-300">
              {/* Icon */}
              <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center text-white mb-4">
                {initiative.icon}
              </div>
              
              {/* Title */}
              <h3 className="font-inter text-lg font-semibold text-gray-900 mb-3">
                {initiative.title}
              </h3>
              
              {/* Description */}
              <p className="font-inter text-sm text-gray-600 leading-relaxed">
                {initiative.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className=" rounded-2xl p-12 text-center relative overflow-hidden" style={{ backgroundColor: '#0A1F5C' }}>
          {/* Bottom Left Circle */}
          <div className="absolute bottom-0 left-0 w-40 h-40 border-4 border-white rounded-full -translate-x-28 translate-y-10 opacity-30"></div>

          {/* Top Right Circle */}
          <div className="absolute top-0 right-0 w-40 h-40 border-4 border-white rounded-full translate-x-28 -translate-y-10 opacity-30"></div>

          <div className="relative z-10">
            <h2 className="font-inter font-medium text-3xl md:text-4xl font-bold text-white mb-8">
              Let's Build The Future Together
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4 font-inter">
              <a href="/services">
                <button className="px-8 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors duration-300">
                  Learn More
                </button>
              </a>
              <a href="/contact">
                <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300">
                  Start a Project
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CSR